import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from 'common/store/store';
import { apiRootUrl } from 'common/utils/network/endpoints';

const baseQuery = fetchBaseQuery({
  baseUrl: apiRootUrl,
  prepareHeaders: (headers, { getState, endpoint }) => {
    const { token } = (getState() as RootState).auth;

    if (token) {
      headers.set('authorization', `Bearer ${token.token}`);
    }

    // Capability declaration: this bundle understands the Birthdays hub
    // (dedicated screens for category 14). The API only includes Birthdays
    // in category lists for clients that say so - older native builds
    // would render it as a plain category with none of the special
    // screens, so for them it does not exist (Dan, 2026-08-06).
    headers.set('X-Doqit-Features', 'birthdays');

    // Don't set Content-Type for FormData uploads - browser sets it automatically with boundary
    if (endpoint === 'uploadProfilePicture') {
      // Keep auth token but remove Content-Type for multipart/form-data
      headers.delete('Content-Type');
    } else if (endpoint === 's3UploadAction') {
      headers.set('authorization', '');
      headers.delete('Content-Type');
      headers.set('enctype', 'multipart/form-data');
    } else {
      headers.set('Content-Type', 'application/json');
    }
    headers.set('Accept', 'application/json, text/plain, */*');

    return headers;
  },
});

export default baseQuery;
